export function getProductSku(product) {
	let sku = String(product?.sku || product?.productId || '').split('|');
	return (sku[1] ?? sku[0])?.toLowerCase();
}


const state = {};

const getters = {
	productsBySKU(state, getters, rootState, rootGetters){
		const o = {};
		rootGetters.filterableItems.forEach((block) => {
			block.products.forEach((prod) => {
				const sku = getProductSku(prod);
				if(sku)o[getProductSku(prod)] = {...prod, blockData: block};
			})
		})
		return o;
	}
}

const actions = {
	/**
	 * A valid product contains a sku that is shoppable
	 * @param param0
	 * @param param0.getters
	 * @param product
	 * @returns {boolean}
	 */
	isValidProduct({getters}, product) {
		const sku = getProductSku(product);
		//console.log('!!!!!!isValidProduct:', sku);
		return !!getters.productsBySKU[sku];
	}
}


export default {
	namespaced: true,
	state,
	getters,
	actions
};
